import { render, staticRenderFns } from "./VideoAndAnimationPage.vue?vue&type=template&id=d9b17e86&scoped=true&"
var script = {}
import style0 from "./VideoAndAnimationPage.vue?vue&type=style&index=0&id=d9b17e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b17e86",
  null
  
)

export default component.exports